import { RebuildDirectory, getStaticProps } from '@public/RebuildDirectory'

export { getStaticProps }

export default RebuildDirectory
